function SystemSettings($scope, $rootScope, $state, $timeout, GeneralUtilsService,StaticRangeTranslationService){

    $scope.isSystemLogin = isSystemLogin;
    $scope.existingResellerAdminsCollection = function (state, params) {
        store.fetch({
            path: '/existingResellerAdmins?parentAccountId=1',
            success: function (data) {
                $timeout(function () {
                    $scope.existingResellerAdmins = data.items;
                }, 0);
            },
        });
    };
    $scope.existingResellerAdminsCollection();

    $scope.loadAccount = function(){
        $scope.$root.clearErrors();
        store.fetch({
            path: "getAccountSettings",
            queryParams: {'accountId': $state.params.accountId,'type':'account'},
            success: function(data) {
                $timeout(function(){
                    $scope.account = data;
                    StaticRangeTranslationService.updateStaticRangeTranslationEnabled(data.id,data.staticRangeTranslationEnabled);
                    $scope.orig = angular.copy($scope.account);
                    $scope.initCatoReservedRangeCheckboxAndDisplayValue();
                }, 0);
            }
        });
    };

    // Init the checkbox and the display model accordingly
    $scope.initCatoReservedRangeCheckboxAndDisplayValue = function(){
        $scope.account.isCatoReservedRangeEnabled = $scope.account.catoReservedRange != $scope.account.catoReservedRangeDefault;
        $scope.account.catoReservedRangeDisplay = $scope.account.catoReservedRange;
    };

    // When checkbox disabled returning into default settings from server
    $scope.catoReservedRangeCheckboxChange = function(){
        if ($scope.account.isCatoReservedRangeEnabled){
            if ($scope.account.catoReservedRange != $scope.account.catoReservedRangeDisplay){
                $scope.account.catoReservedRange = $scope.account.catoReservedRangeDisplay;
            }
        }else{
            $scope.account.catoReservedRange = $scope.account.catoReservedRangeDefault;
        }
    }

    $scope.loadAccount();

    $scope.$root.hasChanges = function(){
        if(!$scope.account) return false;
        var tcpChanged = $scope.account.tcpAccelerationExternal != $scope.orig.tcpAccelerationExternal;
        var tcpChanged2 = $scope.account.tcpAccelerationInternal != $scope.orig.tcpAccelerationInternal;
        var restrictPrivateRange = $scope.account.requirePrivateRange != $scope.orig.requirePrivateRange;
        var noVpnConfigurationFile = $scope.account.noVpnConfigurationFile != $scope.orig.noVpnConfigurationFile;
        var seChanged = $scope.account.salesEngAdminId != $scope.orig.salesEngAdminId;
        var staticRangeTranslationChanged =  ($scope.orig.staticRangeTranslationEnabled && ! $scope.account.staticRangeTranslationEnabled) || (!$scope.orig.staticRangeTranslationEnabled && $scope.account.staticRangeTranslationEnabled);
        var releaseGroup = $scope.account.releaseGroup != $scope.orig.releaseGroup;
        var accountProductionType = $scope.account.accountProductionType != $scope.orig.accountProductionType;
        var catoReservedRange = $scope.validateChangeOnCatoReservedRange();
        var enableMetricsChanged = $scope.account.enableMetrics != $scope.orig.enableMetrics;
        var linkExpirationInDaysChanged = $scope.account.linkExpirationInDays != $scope.orig.linkExpirationInDays;
        var isOverlappingIPEnableChanged = $scope.account.isOverlappingIPEnable != $scope.orig.isOverlappingIPEnable;

        return (linkExpirationInDaysChanged || enableMetricsChanged || seChanged || staticRangeTranslationChanged || tcpChanged || tcpChanged2 || restrictPrivateRange || noVpnConfigurationFile || releaseGroup || catoReservedRange || isOverlappingIPEnableChanged || accountProductionType || hasMfaChanged());
    };

    // Checking if can save changes on catoReservedRange,
    $scope.validateChangeOnCatoReservedRange = function(){
        if ($scope.account.isCatoReservedRangeEnabled){
            return $scope.account.catoReservedRangeDisplay != $scope.orig.catoReservedRange;
        }else{
            return $scope.orig.catoReservedRange != $scope.account.catoReservedRangeDefault;
        }
    };

    $scope.saveChanges = function(){
        if(!$scope.orig.isOverlappingIPEnable && $scope.account.isOverlappingIPEnable) {
            $rootScope.confirm("Enabling the IP Overlapping feature is a permanent change and you can't disable it in the future. Do you want to save the changes to enable IP Overlapping?", saveFunc, 'Save');
        } else {
            saveFunc();
        }
    };

    function saveFunc() {
        // send save request
        $scope.account.newSaveMethod = true;
        var fields;
        if ($scope.isSystemLogin) {
            fields = "['tcpAccelerationExternal','tcpAccelerationInternal', 'requirePrivateRange','mfaSettings','salesEngAdminId', 'noVpnConfigurationFile', 'releaseGroup','staticRangeTranslationEnabled', 'isOverlappingIPEnable', 'catoReservedRange','enableMetrics', 'linkExpirationInDays', 'accountProductionType']";
        } else {
            fields = "['tcpAccelerationExternal','tcpAccelerationInternal', 'requirePrivateRange','mfaSettings', 'noVpnConfigurationFile','staticRangeTranslationEnabled', 'isOverlappingIPEnable']";
        }

        if ($scope.account.isCatoReservedRangeEnabled){
            $scope.account.catoReservedRange = $scope.account.catoReservedRangeDisplay;
        }else{
            $scope.account.catoReservedRange = $scope.account.catoReservedRangeDefault;
        }

        $scope.loading = true;
        store.save({
            path: "/edit",
            data: $scope.account,
            dataObj: 'json',
            queryParams: {
                'accountId': $state.params.accountId,
                'save':true,
                'fields': fields,
            },
            success: function(data) {
                $timeout(function() {
                    $scope.loading = false;
                }, 0);
                $scope.$root.handleServerResponse(data,"", "Account settings saved successfully");
                if(data.status !== "ERROR"){
                    $scope.loadAccount();
                }
            }
        });
    }

    /**
      * states if the MFA settings has changed
    **/
    function hasMfaChanged(){
        return $scope.orig.mfaSettings !== $scope.account.mfaSettings;
    }

    $scope.openSiteInfo = function(isNeedToOpen){
        if (isNeedToOpen){
            $scope.propertiesModified = new Date();
            $scope.$root.openPopup('ipOverlappingDlg');
        }
    };

    $scope.overlappingTableConfig = {
        defer: true,
        dataURL: function() {
            return '/getSiteForNonSupportedSocketFeatureType?accountId=' + $state.params.accountId + '&featureType=INTER_SITES_IP_OVERLAPPING';
        },
        fields: [
            {"label": "Name", "path": "name", "template": "<span>{{item.name}}</span>"},
            {"label": "Socket Version", "path": "socketVersion", "template": "<span>{{item.socketVersion | socketVersion }}</span>"},
            {"label": "Type", "path": "siteType", "template": "<span>{{item.siteType | capitalize }}</span>"},
        ],
        pageSize: 8,
        titleSearch: "Name",
        sortField: "name",
        searchField: "name",
        type: "Site",
        hideCheckboxes: true,
        clientSidePaging: true,
        clientSideSearch: true,
        clientSideSort: true
    };

    if ($scope.isSystemLogin) {
        store.fetch({
            path: '/getReleaseGroups',
            success: function (data) {
                $timeout(function () {
                    $scope.releaseGroups = data;
                }, 0);
            },
        });

        $scope.accountProductionTypes = [
            {
                name: 'Production',
                value: 'PRODUCTION',
            }, {
                name: 'Development',
                value: 'DEVELOPMENT',
            },
        ];
    }

}